import debounce from "../util/debounce";
export default class ScrollController {
    constructor({
                    STAY_TIME = 2000,
                    EXPOSED_PERCENT = 0.5,
                    isHalfAppPage = false,
                    scrollImpArray,
                    dataSchedule = () => {},
                    track = () => {}
                }) {
        this.STAY_TIME = STAY_TIME; // 有效停留时间/ms
        this.EXPOSED_PERCENT = EXPOSED_PERCENT; // 元素露出百分比
        this.dataSchedule = dataSchedule; // 数据整理回调
        this.isHalfAppPage = isHalfAppPage;
        this.pageScrollObj= {};
        this.bindScrollNode = [];
        this.scrollImpArray = scrollImpArray;
        this.track = track; //曝光函数实现
        this.triggerScrollImp = this.triggerScrollImp.bind(this);
        this.checkScrollImpBind = this.checkScrollImp.bind(this);
        !this.isHalfAppPage && this.bindH5ScrollEvent(); // 若是全h5页面，则采用h5页面自己的监听行为
        this.bindSrollListener(); // 监听自定义滚动元素
        this.handleImphooks();
    }

    handleImphooks() {
        window.imphooks = window.imphooks ? window.imphooks : {};
        window.imphooks.scrollControllers = window.imphooks.scrollControllers || [];
        window.imphooks.scrollControllers.push(this);
        if (window.imphooks.loaclPageObj) this.pageScrollObj = window.imphooks.loaclPageObj;
        window.imphooks.setPageSize = ((srollObject) => {
            window.imphooks.scrollControllers.forEach(item => {
                item.triggerScrollImp && item.triggerScrollImp(srollObject)
            })
        });
        
    }

    bindH5ScrollEvent() {
        window.addEventListener('scroll',() => {
            this.triggerScrollImp();
        });
        // 初始情况下先触发一次首屏的埋点
        this.triggerScrollImp();
    }

    eleCanScroll(ele) {
        if (!ele instanceof HTMLElement) {
            return false;
        }
        if (ele.scrollTop > 0) {
            return true;
        } else {
            ele.scrollTop++;
            // 元素不能滚动的话，scrollTop 设置不会生效，还会置为 0
            let top = ele.scrollTop;
            // 重置滚动位置
            top && (ele.scrollTop = 0);
            return top > 0;
        }
    }

    bindSrollListener() {
        let nodes = document.querySelectorAll('[imp-scroll-id]')
        for (let i = 0; i < nodes.length; i++) {
            let id = nodes[i].getAttribute('imp-scroll-id')
            if (this.bindScrollNode.indexOf(id) > -1) {
                continue;
            }
            if ((nodes[i].scrollHeight > nodes[i].clientHeight || nodes[i].scrollWidth > nodes[i].clientWidth) && this.eleCanScroll(nodes[i])) { // 常规滚动
                nodes[i].addEventListener('scroll',() => {
                    this.triggerScrollImp();
                })
            } else {
                nodes[i].addEventListener('touchend',() => {
                    this.triggerScrollImp();
                })
            }
            this.bindScrollNode.push(id);
        }
    }

    getPageScrollObj(status) {
        // 增加监听在滚动开始及结束时，以发送视窗矩形
        // 当前视窗矩形
        let nodeName = document && document.scrollingElement && document.scrollingElement.scrollTop ? 'scrollingElement' : 'documentElement';
        let scrollTop = 0,
            clientHeight = 0;
        scrollTop = document[nodeName].scrollTop;
        clientHeight = document[nodeName].clientHeight;
        return {
            top: scrollTop,
            bottom: scrollTop + clientHeight,
            status
        };
    }

    checkScrollImp() {
        this.bindSrollListener(); // 动态更新监听器
        if (!this.isHalfAppPage) {
            this.pageScrollObj = this.getPageScrollObj('end');
        } else {
            let pageScrollObj = typeof arguments[0] === 'string' ? JSON.parse(arguments[0]) : arguments[0];
            if (pageScrollObj && pageScrollObj.status == 'end') {
                this.pageScrollObj = pageScrollObj;
            }
        }
        if (!(this.pageScrollObj && this.pageScrollObj.status == 'end')) return;
        try {
            let impArray = this.getImpInPageScrollObj(this.pageScrollObj);
            this.sendImpEvent(impArray);
        } catch (error) {
            console.error(error)
        }
    }

    triggerScrollImp(val) {
        debounce(this.checkScrollImpBind, this.STAY_TIME)(val);
    }

    getElementBound(node) {
        let actualTop = (node && node.offsetTop) || 0;
        let current = node && node.offsetParent || null;
        while (current){
            actualTop += current.offsetTop;
            current = current.offsetParent || null;
        }
        let domRect = node.getBoundingClientRect();
        return {top: actualTop, left: domRect.left, right: domRect.right, bottom: actualTop + node.clientHeight};
    }

    getImpInPageScrollObj(pageScrollObj) {
        this.dataSchedule(null, null, null,'start');
        if (this.scrollImpArray.length) {
            for (let index = this.scrollImpArray.length - 1; index >= 0; index--) {
                let impObj = this.scrollImpArray[index];
                let currentEventConfig = impObj.config; // 找到这个点在ExposureImpPage里面的配置对应的配置
                if (!currentEventConfig){
                    // 非滚动曝光
                    // 更新当前tgt_nameMap，便于后续合并埋点
                    this.dataSchedule(impObj, index, []);
                    continue
                }
                // 获取html节点上的唯一标识
                let pointName = impObj[currentEventConfig.paramName];
                if (!pointName) {
                    // 非滚动曝光
                    // 更新当前tgt_nameMap，便于后续合并埋点
                    this.dataSchedule(impObj, index, []);
                    continue
                }
                let $node =
                    document.querySelector(
                        `[imphooks-name="${pointName}"]`
                    ) || document.getElementsByName(pointName)[0];

                if (!$node) {
                    // 滚动曝光节点未挂载
                    // this.exposureScrollArray.push(impObj);
                    // 更新当前tgt_nameMap，便于后续合并埋点
                    // tgt_nameMap = this.updateTgtNameMap(
                    //     tgt_nameMap,
                    //     impObj,
                    //     []
                    // );
                    // this.scrollImpArray.splice(index, 1);
                    continue
                }
                let elementBound = this.getElementBound($node);
                if (this.isElementInScrollObj(
                    pageScrollObj,
                    elementBound,
                )) {
                    // 更新当前tgt_nameMap，便于后续合并埋点
                    this.dataSchedule(impObj, index, ($node && $node.classList) || []);
                }
            }
        }
        return this.dataSchedule(null, null, null, 'end');
    }

    isElementInScrollObj(psObj, elementBound) {
        // 那个事件的元素是否被曝光了
        if (
            psObj.top <= elementBound.top &&
            psObj.bottom >= elementBound.bottom
        ) {
            return this.compareWidth(elementBound);
        } else if (
            psObj.top <= elementBound.top &&
            psObj.bottom < elementBound.bottom
        ) {
            // 元素在页面下方，部分露出
            let percent =
                (psObj.bottom - elementBound.top) /
                (elementBound.bottom - elementBound.top);
            if (this.EXPOSED_PERCENT <= percent) {
                return this.compareWidth(elementBound);
            }
        } else if (
            psObj.top > elementBound.top &&
            psObj.bottom >= elementBound.bottom
        ) {
            // 元素在页面上方，部分露出
            let percent =
                (elementBound.bottom - psObj.top) /
                (elementBound.bottom - elementBound.top);
            if (this.EXPOSED_PERCENT <= percent) {
                return this.compareWidth(elementBound);
            }
        }
        return false;
    }

    compareWidth(elementBound) {
        let left = 0;
        let right = document.body.clientWidth;
        if (elementBound.left >= left && elementBound.right <= right) {
            return true
        } else if (elementBound.left >= left && elementBound.right > right) {
            // 元素在页面右侧，部分露出
            let percent =
                (right - elementBound.left) /
                (elementBound.right - elementBound.left);
            if (this.EXPOSED_PERCENT <= percent) {
                return true;
            }
        } else if (elementBound.left < left && elementBound.right <= right) {
            // 元素在页面左侧，部分露出
            let percent =
                (elementBound.right - left) /
                (elementBound.right - elementBound.left);
            if (this.EXPOSED_PERCENT <= percent) {
                return true;
            }
        }
        return false;
    }

    sendImpEvent(impArray) {
        // 发送imp事件
        while (impArray.length > 0) {
            let item = impArray.pop();
            delete item.config;
            item && this.track(item)
        }
    }

}
